import React from "react";
import { ShieldCheck, TrendingDown } from "lucide-react";
import { useProductInfo } from "../../hooks/useProductInfo";
import { useListingTypeConfig } from "../../hooks/useListingTypeConfig";
import OfferCount from "../../../ProductCard/childComponents/OfferCount";
import ConditionBadge from "../../../../../shared/ConditionBadge";
import "./styles/SummaryCard.css";

const SummaryCard: React.FC = () => {
  const { title, price, isNegotiable, listingType, condition, likesCount, isTrustedSeller, displayPrice } = useProductInfo();
  const { listingTypeConfig } = useListingTypeConfig(listingType);

  const pricingModel = listingTypeConfig?.pricing?.model;
  const isRental = pricingModel === "rental_tiered";
  const priceLabel = isRental
    ? "Starting from"
    : listingTypeConfig?.pricing?.label ?? "Asking Price";

  return (
    <div className="sumv2 glass-card">
      <div className="sumv2__header">
        <ConditionBadge 
          listingType={listingType} 
          condition={condition} 
          className="sumv2__condition-badge" 
        />
        <h1 className="sumv2__title">{title}</h1>
      </div>

      {displayPrice && !isRental && (
        <div className="sumv2__price-section">
          <div className="sumv2__price-header">
            <span className="sumv2__price-label">{priceLabel}</span>
            {likesCount > 0 && (
              <div className="sumv2__offer-count">
                <OfferCount count={likesCount} />
              </div>
            )}
          </div>
          <div className="sumv2__price-display">
            <span className="sumv2__price-big">₹{price.toLocaleString("en-IN")}</span>
            {isNegotiable && (
              <span className="sumv2__negotiable-badge">
                <TrendingDown size={12} strokeWidth={2.5} />
                Negotiable
              </span>
            )}
          </div>
        </div>
      )}

      {isTrustedSeller && (
        <div className="sumv2__trusted-badge">
          <ShieldCheck size={16} strokeWidth={2.5} />
          <span>Trusted Seller</span>
        </div>
      )}
    </div>
  );
};

export default SummaryCard;
